import React from 'react';
import { Flex } from '@components/Flex';
import { getRootUrl } from '@utils/urlHelpers.util';
import {
  StyledBannerContainer,
  StyledNavText,
  StyledArrowIcon,
  StyledLabelCTA,
  StyledCTAText,
  WrapperSlider,
  ContentSlider,
  TextHiddenOnMobile,
  MobileStyledArrowIcon,
} from './AnnounceBannerValueProps.styles';

interface Props {
  opacity: number;
}

export const AnnounceBannerValueProps = ({ opacity }: Props) => {
  return (
    <StyledBannerContainer href={getRootUrl(`/registry`)} opacity={opacity}>
      <Flex marginRight={[0, 3]}>
        <StyledNavText>
          <TextHiddenOnMobile>All-in-One Wedding</TextHiddenOnMobile>&nbsp;Registry with&nbsp;
        </StyledNavText>

        <WrapperSlider>
          <ContentSlider>
            Free Shipping <MobileStyledArrowIcon />
            <br />
            Post-Wedding Discount <MobileStyledArrowIcon />
            <br />
            Zero-Fee Cash Funds <MobileStyledArrowIcon />
            <br />
            Easy Returns <MobileStyledArrowIcon />
            <br />
            Free Shipping <MobileStyledArrowIcon />
          </ContentSlider>
        </WrapperSlider>
      </Flex>
      <StyledCTAText>
        <Flex marginRight={3} alignItems="center">
          <StyledLabelCTA>Learn More</StyledLabelCTA> <StyledArrowIcon />
        </Flex>
      </StyledCTAText>
    </StyledBannerContainer>
  );
};
